import React, { Component } from 'react'
import classnames from 'classnames'

import Button from '../components/Button'
import Icon from '../components/Icon'
import Video from '../components/Video'
import PageHeader from '../components/PageHeader'
import PageSection from '../components/PageSection'
import GenericCtaModule from '../components/GenericCtaModule'
import AnimatedSvgCirclePathInView from '../components/AnimatedSvgCirclePathInView'
import InViewMonitor from 'react-inview-monitor'

const WPheroForegroundImage = '/static/images/technology/linked-bubbles.svg'

const stackItems = [
  {
    imageEl: <img src='/static/images/bedroom.svg' className='mb2' />,
    caption: "“Can you dim a bit the lights in the kid's bedroom?”"
  },
  {
    imageEl: <img src='/static/images/garden.svg' className='mb2' />,
    caption: '“Could you switch the garden lights to blue?”'
  },
  {
    imageEl: (
      <AnimatedSvgCirclePathInView strokeColor='#001EFF' percentage={93} />
    ),
    caption: 'Sound to meaning F1-score'
  }
]

class AnimatedVideoOnHover extends Component {
  constructor () {
    super()
    this.state = {
      isPlaying: false
    }
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
  }

  handleMouseEnter () {
    this.setState({ isPlaying: true })
  }

  handleMouseLeave () {
    this.setState({ isPlaying: false })
  }

  render () {
    const { videoSrc, poster } = this.props
    return (
      <div
        className='technology-page__data-generation-section__animated-video'
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <InViewMonitor childPropsInView={{ src: videoSrc }}>
          <Video
            poster={poster}
            controls={false}
            loop
            isPlaying={this.state.isPlaying}
          />
        </InViewMonitor>
      </div>
    )
  }
}

function DataGenerationItemsList ({ items }) {
  return (
    <ul className='col-10 flex flex-wrap justify-around center mx-auto'>
      {items &&
        items.map(({ title, content, id }) => (
          <li
            className='technology-page__data-generation-section__list-item md-col-4 px2 mx-auto center'
            key={id}
          >
            <AnimatedVideoOnHover
              videoSrc={`/static/videos/data-generation_${id}.mp4`}
              poster={`/static/images/technology/data-generation_${id}.png`}
            />
            <div
              className='technology-page__data-generation-section__list-item-title h3 mb2'
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <p className='col-10 text-para mx-auto'>{content}</p>
          </li>
        ))}
    </ul>
  )
}

function FeaturesItemsList ({ items }) {
  return (
    <ul className='text-para white'>
      {items.map(({ image, listItem }, idx) => (
        <li key={idx} className='mb2 flex items-center'>
          <img src={`/static/images/icons/${image}.svg`} className='mr2' />
          <span>{listItem}</span>
        </li>
      ))}
    </ul>
  )
}

function ResearchCard ({ title, content, url, image }) {
  return (
    <div className='technology-page__research-card mx2'>
      <div
        className='technology-page__research-card__media left-align py2 px3 mx-auto mb3'
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8) 20%, rgba(0, 0, 0, 0.1)), url(${image})`
        }}
      >
        <div
          className='white small mb3 technology-page__research-card__text'
          dangerouslySetInnerHTML={{ __html: content }}
        />
        {url && (
          <Button
            className='technology-page__research-card__btn button button--outline'
            href={url}
            target='_blank'
          >
            Read more
          </Button>
        )}
      </div>
      <h3 className='h4 mb2'>{title}</h3>
    </div>
  )
}

function AnimatedSpeechBubble ({ content }) {
  return (
    <InViewMonitor
      classNameNotInView='md-col-8 mx-auto vis-hidden'
      classNameInView='technology-page__features-section__speech-bubble__content md-col-8 mx-auto absolute animated scaleFadeIn'
    >
      <div className='technology-page__features-section__speech-bubble__content__text bg-white text-color p2'>
        <p className='mb0'>{content}</p>
      </div>
    </InViewMonitor>
  )
}

export const TechnologyPage = ({
  data: {
    acf: {
      heroTitle,
      featuresItems,

      dataGenerationTitle,
      dataGenerationSubtitle,
      dataGenerationItems,

      stackTitle,

      mediaSections,

      researchTitle,
      researchProjects,
      researchButton
    }
  }
}) => {
  return (
    <main className='technology-page main maxw-xxlarge mx-auto'>
      <PageHeader extraClass='technology-page__page-header' title={heroTitle}>
        <figure className='pt2'>
          <img className='fit mb1' src={WPheroForegroundImage} />
          <figcaption className='col-12 lg-col-10 strong small flex justify-around mx-auto mb4'>
            {featuresItems &&
              featuresItems.map(({ title }) => (
                <span key={title}>{title}</span>
              ))}
          </figcaption>
          <div className='grey medium'>
            Our technology runs on-device, works offline and guarantees <br />
            Privacy by Design
          </div>
        </figure>
      </PageHeader>

      {featuresItems &&
        featuresItems.map(
          (
            { title, mediaPosition, illustration, items, speechBubbles },
            idx
          ) => {
            const classes = classnames(
              {
                'technology-page__features-section__list-outer--reversed':
                  mediaPosition === 'left'
              },
              'flex justify-around items-center px2'
            )
            const { url } = illustration
            return (
              <PageSection
                key={title}
                extraClass='technology-page__features-section relative white'
              >
                <div className={classes}>
                  <div className='technology-page__features-section__list-inner px2'>
                    <h3 className='h3 mb3'>{title}</h3>
                    <FeaturesItemsList key={`${title}-${idx}`} items={items} />
                  </div>
                  <div
                    style={{ backgroundImage: `url(${url})` }}
                    className='technology-page__features-section__illustration relative xs-hide sm-hide'
                  >
                    {speechBubbles.map(({ content }, idx) => (
                      <AnimatedSpeechBubble key={idx} content={content} />
                    ))}
                  </div>
                </div>
              </PageSection>
            )
          }
        )}

      <PageSection extraClass='technology-page__data-generation-section'>
        <div className='col-10 md-col-12 mx-auto center'>
          <h2 className='h2 mb1 pt3 center'>{dataGenerationTitle}</h2>
          <p className='maxw-text mx-auto text-para subtitle mb4'>
            {dataGenerationSubtitle}
          </p>
        </div>
        <DataGenerationItemsList items={dataGenerationItems} />
      </PageSection>

      <PageSection extraClass='technology-page__stack-section bg-light-grey center'>
        <div className='bg-light-grey md-col-10 mx-auto p2'>
          <h2 className='h2 h2-mb '>Performances</h2>
          <div className='flex flex-wrap justify-center items-start mb2'>
            {stackItems.map(({ imageEl, caption }) => (
              <figure
                key={caption}
                className='technology-page__stack-section__figure relative p3'
              >
                {imageEl}
                <figcaption className='strong'>{caption}</figcaption>
              </figure>
            ))}
          </div>
          <Button
            className='button button--secondary'
            target='_blank'
            href='https://arxiv.org/abs/1805.10190'
          >
            More info
          </Button>
        </div>
      </PageSection>

      <PageSection extraClass='technology-page__research-section bg-primary white center'>
        <h2 className='h2 h2-mb'>{researchTitle}</h2>
        <div className='technology-page__research-section__projects flex flex-wrap justify-center md-col-10 mx-auto mb4'>
          {researchProjects &&
            researchProjects.map((researchProject, index) => (
              <ResearchCard key={index} {...researchProject} />
            ))}
        </div>
        <div className='inline-flex items-center'>
          <Icon icon='github' className='icon icon--large mr2' />
          <Button
            className='button button--outline flex justify-between'
            href='https://github.com/snipsco'
            target='_blank'
          >
            <span className='mr3'>{researchButton}</span>
            <Icon icon='carousel-arrow-right' />
          </Button>
        </div>
      </PageSection>

      <PageSection extraClass='bg-white'>
        <GenericCtaModule />
      </PageSection>
    </main>
  )
}

export default TechnologyPage



// WEBPACK FOOTER //
// ./frontend/scripts/react/pages/TechnologyPage.js